import { render, staticRenderFns } from "./NewBookings.vue?vue&type=template&id=00a6e671&scoped=true&"
import script from "./NewBookings.vue?vue&type=script&lang=js&"
export * from "./NewBookings.vue?vue&type=script&lang=js&"
import style0 from "./NewBookings.vue?vue&type=style&index=0&id=00a6e671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a6e671",
  null
  
)

export default component.exports